import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// EMPLOYEE EXIT APIs
// ==============================================

// 1. Get Employees For Exit (GET) - Search employees by prefix (autocomplete)
export const getEmployeesForExit = async (prefix) => {
    try {

        const response = await axios.get(
            `${API_BASE_URL}/HR/GetEmployeesForExit`,
            {
                params: { Prefix: prefix },
                headers: { 'Content-Type': 'application/json' },
            }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to get employees for exit';
    }
};

// 2. Get Employee For Exit (GET) - Get employee details by EmpRefNo
export const getEmployeeForExit = async (empRefNo) => {
    try {

        const response = await axios.get(
            `${API_BASE_URL}/HR/GetEmployeeForExit`,
            {
                params: { EmpRefno: empRefNo },
                headers: { 'Content-Type': 'application/json' },
            }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to get employee for exit';
    }
};

// 3. Save Employee Exit (POST) - Calls spInsertEmpExit
//
// ── FIELD NAME CONTRACT ───────────────────────────────────────────────────────
// SP params: @CCCode, @EmpRefNo, @GroupId, @ResignationDate, @RelievingDate,
//            @Remarks, @DocBaseString (binary), @DocBase, @DocType,
//            @Createdby, @RoleId
// Returns "@AddStatus" = "Submited" on success
// ─────────────────────────────────────────────────────────────────────────────
export const saveEmpExit = async (params) => {
    try {

        if (!params.costCenter)       throw new Error('Cost Center is required');
        if (!params.empRefNo)         throw new Error('Employee Ref No is required');
        if (!params.groupId)          throw new Error('Group ID is required');
        if (!params.resignationDate)  throw new Error('Resignation Date is required');
        if (!params.relievingDate)    throw new Error('Relieving Date is required');
        if (!params.createdBy)        throw new Error('Created By is required');
        if (!params.roleId)           throw new Error('Role ID is required');

        const payload = {
            CostCenter:      params.costCenter?.toString()      || '',
            EmpRefNo:        params.empRefNo?.toString()        || '',
            GroupId:         parseInt(params.groupId),
            ResignationDate: params.resignationDate?.toString() || '',
            RelievingDate:   params.relievingDate?.toString()   || '',
            Remarks:         params.remarks?.toString()         || '',
            DocBaseString:   params.docBaseString?.toString()   || '',
            DocType:         params.docType?.toString()         || '',
            Createdby:       params.createdBy?.toString()       || '',
            RoleId:          parseInt(params.roleId),
        };


        const response = await axios.post(
            `${API_BASE_URL}/HR/SaveEmpExit`,
            payload,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to save employee exit';
    }
};

// 4. Get Verify Employee Exit Grid (GET) - Inbox list by role
export const getVerifyEmpExit = async (roleId) => {
    try {

        const response = await axios.get(
            `${API_BASE_URL}/HR/GetVerifyEmpExit`,
            {
                params: { RoleID: roleId },
                headers: { 'Content-Type': 'application/json' },
            }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to get verify employee exit grid';
    }
};

// 5. Get Employee Exit By ID (GET) - Detail view for a single exit record
export const getEmpExitById = async (params) => {
    try {

        const response = await axios.get(
            `${API_BASE_URL}/HR/GetEmpExitbyId`,
            {
                params: {
                    Emprefno: params.empRefNo,
                    Id:       params.id,
                    RoleId:   params.roleId,
                },
                headers: { 'Content-Type': 'application/json' },
            }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to get employee exit by id';
    }
};

// 6. Approve Employee Exit (PUT) - Calls spApproveEmpExit
//
// ── FIELD NAME CONTRACT ───────────────────────────────────────────────────────
// SP params: @Id, @CCCode, @Emprefno, @GroupId, @ResignationDate,
//            @RelievingDate, @Roleid, @Createdby, @Action, @Note
// ─────────────────────────────────────────────────────────────────────────────
export const approveEmpExit = async (params) => {
    try {

        if (!params.id)        throw new Error('Record ID is required');
        if (!params.Action)    throw new Error('Action is required (Approve / Verify / Reject)');
        if (!params.CreatedBy) throw new Error('CreatedBy is required');
        if (!params.RoleId)    throw new Error('RoleId is required');

        const payload = {
            Id:              parseInt(params.id),
            CostCenter:      params.costCenter?.toString()      || '',
            EmpRefNo:        params.empRefNo?.toString()        || '',
            GroupId:         parseInt(params.groupId)           || 0,
            ResignationDate: params.resignationDate?.toString() || '',
            RelievingDate:   params.relievingDate?.toString()   || '',
            RoleId:          parseInt(params.RoleId),
            Createdby:       params.CreatedBy?.toString()       || '',
            Action:          params.Action?.toString()          || '',
            Note:            params.Note?.toString()            || '',
        };


        const response = await axios.put(
            `${API_BASE_URL}/HR/ApproveEmpExit`,
            payload,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to approve employee exit';
    }
};
